// Script to properly handle header and overlay for search functionality
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-wrapper');
  const overlay = document.getElementById('search-overlay');
  
  // Function to position overlay correctly
  function updateOverlayPosition() {
    if (header && overlay) {
      const headerRect = header.getBoundingClientRect();
      const headerHeight = headerRect.height;
      
      // Set custom property that can be used in CSS
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      
      // Explicitly set the top position of the overlay
      if (overlay) {
        overlay.style.top = headerHeight + 'px';
        
        // Force a repaint to ensure the new position is applied
        void overlay.offsetWidth;
      }
    }
  }
  
  // Run initially
  updateOverlayPosition();
  
  // Update on window resize and scroll
  window.addEventListener('resize', updateOverlayPosition);
  window.addEventListener('scroll', function() {
    // Only update if search is active
    if (overlay && overlay.classList.contains('active')) {
      // Use requestAnimationFrame for smooth performance
      requestAnimationFrame(updateOverlayPosition);
    }
  });
  
  // Check for class changes on overlay
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class' && overlay.classList.contains('active')) {
        updateOverlayPosition();
      }
    });
  });
  
  // Start observing the overlay for class changes
  if (overlay) {
    observer.observe(overlay, { attributes: true });
  }
  
  // Check when search becomes active
  const searchToggle = document.getElementById('search-toggle');
  if (searchToggle) {
    searchToggle.addEventListener('click', function() {
      // Short delay to ensure elements are rendered before calculating
      setTimeout(updateOverlayPosition, 10);
    });
  }
});
